<template>
  <div>
    <ls-card>
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }" class="form-area">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="需求组织">
              <global-select
                v-decorator="['organizationCode', { rules: [{ required: true, message: '请选择需求组织' }] }]"
                selectType="selectAssemble"
                :selectData="inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :assembleLabel="true"
                :allowClear="false"
                :disabled="organizationCodeDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="叫料单号">
              <a-input v-decorator="['callDocNumber']" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <global-select
                v-decorator="['orderType', { rules: [{ required: true, message: '请选择类型' }] }]"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_CALL_DOC_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="要求到货时间" :labelCol="{ style: { width: '95px' } }">
              <a-date-picker v-decorator="['demandDate', { rules: [{ required: true, message: '请选择要求到货时间' }] }]" :disabled-date="disabledDate" valueFormat="YYYY-MM-DD HH:mm:ss" />
            </a-form-item>
          </a-col>
          <a-col :md="15" :sm="24">
            <a-form-item label="备注" class="comment-w">
              <a-input v-decorator="['comment']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="aj-center-end">
              <a-button class="ml8" :loading="allDeleteLoading" @click="allDelete" v-hasPermi="['scp:invCallRequestLines:entireDelete']">整单删除</a-button>
              <a-button class="ml8" @click="handleCancel">取消</a-button>
              <a-button class="ml8" :loading="saveLoading" @click="handleSave('save')" v-hasPermi="['scp:invCallRequestLines:save']">保存</a-button>
              <a-button type="primary" class="ml8" :loading="publishLoading" @click="handleSave('savePublish')" v-hasPermi="['scp:invCallRequestLines:savePublish']">保存并发布</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </ls-card>

    <ls-card>
      <template #title>叫料明细</template>
      <div><a-button type="primary" :disabled="!form.getFieldsValue().organizationCode" @click="addLine">添加行</a-button></div>
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="indexId"
        :scroll="{ x: 1800, fixScreen: true, extraHeight: 0 }"
      >
        <span slot="itemCodeTitle">
          <i class="toRequired">*</i>物料编码
        </span>
        <span slot="uomTitle">
          <i class="toRequired">*</i>单位
        </span>
        <span slot="demandQtyTitle">
          <i class="toRequired">*</i>需求量
        </span>
        <span slot="lotNumberTitle">
          <i class="toRequired">*</i>批次号
        </span>
        <template v-for="item in columns" slot-scope="{ text, record }" :slot="item.dataIndex">
          <div :key="item.dataIndex">
            <span v-if="item.dataIndex === 'operation'">
              <a class="ml10" @click="handleDelete(record)" v-hasPermi="['scp:invCallRequestLines:delete']">删除</a>
            </span>
            <span v-else-if="item.type === 'select'">
              <global-select
                :value.sync="record[item.dataIndex]"
                :selectType="item.selectType ? item.selectType : 'select'"
                :focusGet="item.focusGet ? item.focusGet : false"
                :requestApi="item.requestApi"
                :selectData="setArray(item.dataList, record)"
                :selectItem="{ value: item.value, label: item.label, thirdLabel: item.thirdLabel }"
                :searchParam="item.searchParam ? item.searchParam : ''"
                :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                :setUrlParams="item.setUrlParams ? setUrlParamsHandle(record, item.dataIndex) : null"
                :sourseField="item.sourseField ? item.sourseField : ''"
                :allowClear="false"
                :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                :disabled="item.disabled"
                size="small"
                :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                @change="(val, list) => selectChange(val, list, record, item.dataIndex)"
              />
            </span>
            <span v-else-if="item.type === 'input'">
              <a-input v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'inputNumber'">
              <a-input-number v-model="record[item.dataIndex]" :min="0" size="small" />
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </template>
      </ls-api-table>
    </ls-card>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import {
  apiInvCallRequestLinesObtainEditingData,
  apiInvCallRequestLinesPrimaryUomBox,
  apiInvCallRequestLinesDelete,
  apiInvCallRequestLinesEntireDelete,
  apiInvCallRequestLinesInsert,
  apiInvCallRequestLinesSavePublish,
  apiUserInventOrgAll,
  apiInvCallRequestLinesDemandWipEntityNameBox, getInfo2
} from '@/api/scp/factoryCallMaterial/callMaterialManage'
// import { generateLsTableResData } from '@/utils/util.js';
export default {
  // eslint-disable-next-line
  name: 'call-material-manage-detail',
  data () {
    return {
      tableProps: {
        requestApi: "",
        pageCurrent: true
      },
      isEdit: false,
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '行号',
          dataIndex: 'lineNumber',
          align: 'center',
          width: 60,
          fixed: 'left'
        },
        {
          // title: '物料编码',
          dataIndex: 'itemId',
          scopedSlots: { customRender: 'itemId', title: "itemCodeTitle" },
          width: 150,
          fixed: 'left',
          type: "select",
          focusGet: true,
          setParams: true,
          dataList: "itemCodeList",
          requestApi: '/inv/invCallRequestLines/itemBoxNoOrg',
          value: 'realValue',
          label: 'label',
          thirdLabel: 'bringOutDataFour',
          selectType: 'selectSearch',
          searchParam: 'label',
          dropdownMatchSelectWidth: false
        },
        {
          // title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom', title: "uomTitle" },
          width: 150,
          fixed: 'left',
          type: "select",
          focusGet: true,
          setParams: true,
          dataList: "uomList",
          requestApi: '/inv/invCallRequestLines/primaryUomBox',
          value: 'realValue',
          label: 'label',
          disabled: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '需求工单号',
          dataIndex: 'demandWipEntityId',
          scopedSlots: { customRender: 'demandWipEntityId' },
          width: 180,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          setParams: true,
          searchParam: "wipEntityName",
          dataList: "wipEntityNameList",
          requestApi: "/inv/invCallRequestLines/demandWipEntityNameBox",
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '需求量',
          dataIndex: 'demandQty',
          scopedSlots: { customRender: 'demandQty', title: "demandQtyTitle" },
          type: "inputNumber"
        },
        {
          title: '供应组织',
          dataIndex: 'supplyOrganizationCode',
          scopedSlots: { customRender: 'supplyOrganizationCode' },
          type: "select",
          dataList: "supplyOrganizationNameList",
          value: 'realValue',
          label: 'label'
        },
        {
          title: '供应商',
          dataIndex: 'supplierId',
          scopedSlots: { customRender: 'supplierId' },
          type: "select",
          focusGet: true,
          setParams: true,
          dataList: "supplierNameList",
          requestApi: '/inv/invCallRequestLines/supplierBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '批次号',
          dataIndex: 'lotNumber',
          scopedSlots: { customRender: 'lotNumber', title: "lotNumberTitle" },
          type: "input"
        },
        {
          title: '零部件工单',
          dataIndex: 'supplyWipEntityId',
          scopedSlots: { customRender: 'supplyWipEntityId' },
          width: 180,
          type: "select",
          focusGet: true,
          setUrlParams: true,
          dataList: "supplyWipEntityNameList",
          requestApi: '/inv/invCallRequestLines/demandWipEntityNameOutParts',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      status: "", // 新增 编辑
      saveLoading: false,
      publishLoading: false,
      organizationCodeDisabled: false, // 需求组织
      wipEntityNameList: [], // 需求工单号
      uomList: [], // 单位
      supplyOrganizationNameList: [], // 供应组织
      detailId: "",
      inventOrg: [], // 用户所在的组织
      inventOrgList: [], // 组织
      allDeleteLoading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    to.meta.title = to.query.status === "add" ? '叫料单管理：新增' : '叫料单管理：编辑'
    next();
  },
  // computed: {
  //   ...mapState({
  //     inventOrg: (state) => state.user.inventOrg
  //   })
  // },
  created () {
    const { status, data } = this.$route.query
    this.status = status || null;
    if (status === "edit") {
      this.detailId = JSON.parse(data).id
      this.$nextTick(() => {
        this.form.setFieldsValue(JSON.parse(data))
      })
      this.getDetail()
    }
    this.getItemCodeList()
    this.getInventOrg()
  },
  mounted () {},
  methods: {
    // 获取用户组织（排除产业园二期）
    getInventOrg() {
      this.inventOrg = []
      this.inventOrgList = []
      getInfo2().then(res => {
        if (res?.code === 200 && res?.data?.inventOrg?.length > 0) {
          this.inventOrg = res.data.inventOrg
          // 组织下拉框去除选项中的库存组织四个字
          const arr = JSON.parse(JSON.stringify(this.inventOrg))
          arr.forEach(element => {
            const num = element.label.indexOf("库存组织")
            if (num > 0) {
              element.label = element.label.substring(0, num)
            }
          });
          this.inventOrgList = arr
        }
      })
    },
    // 要求到货时间-选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    },
    // 保存并发布
    handleSave (val) {
      this.form.validateFields((err, values) => {
        if (!err) {
          const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
          let flag = false
          if (arr.length === 0) {
            this.$message.error("叫料明细不能为空")
            return
          }
          for (let i = 0; i < arr.length; i++) {
            if (!arr[i].itemId || !arr[i].uom) {
              flag = true
              this.$message.error("必填项不能为空")
              return
            }
            if (!arr[i].lotNumber) {
              flag = true
              this.$message.error("批次号不能为空")
              return
            }
            if (!arr[i].demandQty) {
              flag = true
              this.$message.error("需求量不能为空且需大于0")
              return
            }
            const obj = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
            arr[i] = Object.assign(arr[i], obj)
          };
          if (flag) {
            return false
          }
          val === "save" && this.save(arr)
          val === "savePublish" && this.savePublish(arr)
        } else {
          this.saveLoading = false
          this.publishLoading = false
        }
      });
    },
    // 保存并发布
    savePublish (arr) {
      this.publishLoading = true
      apiInvCallRequestLinesSavePublish(arr).then(response => {
        if (response.code === 200) {
          this.$message.success('保存并发布成功')
          this.event.$emit("close-current-page");
          this.publishLoading = false
        } else {
          this.$message.error(response.msg)
          this.publishLoading = false
        }
      }).catch(e => {
        this.publishLoading = false
      })
    },
    // 保存
    save (arr) {
      this.saveLoading = true
      apiInvCallRequestLinesInsert(arr).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.event.$emit("close-current-page");
          this.saveLoading = false
        } else {
          this.$message.error(response.msg)
          this.saveLoading = false
        }
      }).catch(e => {
        this.saveLoading = false
      })
    },
    // 整单删除
    allDelete () {
      const arr = this.$refs.dataTable.myDataSource
      const params = []
      arr.forEach(element => {
        if (element.id) {
          params.push(element.id)
        }
      });
      if (params.length === 0) {
        this.$message.success('整单删除成功!');
        this.event.$emit("close-current-page");
        return
      }
      const self = this
      this.$confirm({
        title: '你确定要整单删除吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          this.allDeleteLoading = true
          apiInvCallRequestLinesEntireDelete(params).then(response => {
            if (response.code === 200) {
              self.$message.success('整单删除成功!')
              self.event.$emit("close-current-page");
            } else {
              self.$message.error(response.msg)
            }
            this.allDeleteLoading = false
          }).catch(e => {
            this.allDeleteLoading = false
          })
        },
        onCancel () {
          this.allDeleteLoading = false
        }
      })
    },
    // 删除
    handleDelete (record) {
      if (record.id) {
        apiInvCallRequestLinesDelete(record.id).then(response => {
          if (response.code === 200) {
            this.$message.success('删除成功!')
            this.getDetail()
          } else {
            this.$message.error(response.msg)
          }
        })
      } else {
        const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
        arr.forEach((item, index) => {
          if (item.indexId === record.indexId) {
            arr.splice(index, 1);
          }
        });
        arr.forEach((item, index) => {
          item.indexId = index + 1
        });
        this.$refs.dataTable.myDataSource = arr
        this.getOrganizationCodeDisabled(this.$refs.dataTable.myDataSource)
      }
    },
    getItemCodeList () {
      // 单位
      apiInvCallRequestLinesPrimaryUomBox({ organizationCode: this.form.getFieldsValue().organizationCode, pageNum: 1, pageSize: 999999 }).then(res => {
        this.uomList = res.rows
      })
      // 供应组织
      apiUserInventOrgAll().then(res => {
        res.data.forEach(element => {
          const reg1 = new RegExp("库存组织");
          element.label = element.label.replace(reg1, "");
        });
        this.supplyOrganizationNameList = res.data
      })
      // 需求工单号
      apiInvCallRequestLinesDemandWipEntityNameBox().then(res => {
        this.wipEntityNameList = res.rows
      })
    },
    // 页面-列表数据
    getDetail () {
      apiInvCallRequestLinesObtainEditingData(this.detailId).then(res => {
        this.getOrganizationCodeDisabled(res.data)
        if (res.data && res.data.length > 0) {
          res.data.forEach((element, index) => {
            const arr = []
            const arr2 = []
            const arr3 = []
            arr.push({ realValue: element.itemId, label: element.itemCode, bringOutDataFour: element.itemCode })
            arr2.push({ realValue: element.supplyWipEntityId, label: element.supplyWipEntityName })
            arr3.push({ realValue: element.supplierId, label: element.supplierName })
            element.itemCodeList = arr // 物料编码
            element.supplyWipEntityNameList = arr2 // 零部件工单
            element.supplierNameList = arr3 // 供应商
            element.indexId = index + 1
          });
          this.$refs.dataTable.myDataSource = res.data
        }
      })
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        itemId: "",
        uom: "",
        itemName: "",
        specification: "",
        demandWipEntityId: "",
        // demandDate: "",
        demandQty: "",
        supplyOrganizationCode: "",
        supplierId: "",
        lotNumber: "",
        supplyWipEntityId: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.$refs.dataTable.myDataSource = arr
      this.getOrganizationCodeDisabled(this.$refs.dataTable.myDataSource)
    },
    // 取消
    handleCancel () {
      this.event.$emit("close-current-page");
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "itemId") {
        return { invTransactionsEnabledFlag: 'Y', organizationCode: this.form.getFieldsValue().organizationCode }
      }
      if (dataIndex === "uom") {
        return { organizationCode: this.form.getFieldsValue().organizationCode }
      }
      if (dataIndex === "demandWipEntityId") {
        return { desOrganizationCode: this.form.getFieldsValue().organizationCode }
      }
    },
    setUrlParamsHandle (record, dataIndex) {
      if (dataIndex === "supplyWipEntityId") {
        return record.demandWipEntityName
      }
    },
    selectChange (val, list, record, dataIndex) {
      if (dataIndex === "itemId") {
        record['itemName'] = this.$getFlagName(list, val, 'realValue', 'bringOutDataOne')
        record['specification'] = this.$getFlagName(list, val, 'realValue', 'bringOutDataTwo')
        record['uom'] = this.$getFlagName(list, val, 'realValue', 'bringOutDataThree')
      }
      if (dataIndex === "demandWipEntityId") {
        record.demandWipEntityName = this.$getFlagName(list, val, 'realValue', 'label')
        this.columns = JSON.parse(JSON.stringify(this.columns))
      }
      if (dataIndex === "supplyWipEntityId") {
        record.supplyOrganizationCode = this.$getFlagName(list, val, 'realValue', 'bringOutDataOne')
      }
    },
    setArray (arr, record) {
      // 物料编码、零部件工单、供应商
      if (arr === "itemCodeList" || arr === "supplyWipEntityNameList" || arr === "supplierNameList") {
        return record[arr]
      }
      return this[arr]
    },
    getOrganizationCodeDisabled (arr) {
      this.organizationCodeDisabled = arr && arr.length > 0
    }
  }
}
</script>

<style scoped lang="less">
.form-area{
  /deep/.ant-select{
    width: 170px !important;
  }
  input{
    width: 170px;
  }
  .ant-calendar-picker {
    width: 160px;
  }
  .remark{
    /deep/.ant-form-item-control-wrapper{
      width: 550px !important;
    }
  }
}
/deep/.ant-pagination{
  display: none;
}
/deep/.ant-select{
  width: 100%;
}
/deep/.ant-input-number{
  width: 100%;
}
input{
  width: 100%;
}
.comment-w {
  /deep/.ant-input{
    width: 300px;
  }
}
</style>
